// Vendors
import { useState } from 'react';
// Handlers
import { LandingOptionsModalFooterHandlers } from '../handlers/landing-options-modal-footer.handlers';
// Types
import { LandingOptionsModalFooterComponentType } from '../types/landing-options-modal-footer.component.type';
import { LandingOptionsModalFooterHookType } from './types/landing-options-modal-footer.hook.type';

const useLandingOptionsModalFooterHook = <T>(
  props: Omit<LandingOptionsModalFooterComponentType<T>, 'disabled'>
): LandingOptionsModalFooterHookType => {
  const [loading, setLoading] = useState(false);

  return { ...LandingOptionsModalFooterHandlers<T>({ ...props, setLoading }), loading };
};

export { useLandingOptionsModalFooterHook };
